import { c as _c } from "react/compiler-runtime";
import React from 'react';
import FeatureLine from './feature-line';
import type { ContentForPricingFeatureBloc, ContentForPricingPlan } from '@/services/sanity/api/get-pricing-features';
import styles from './feature-bloc.module.css';
interface FeatureBlocProps {
  bloc: ContentForPricingFeatureBloc;
  plan: ContentForPricingPlan;
}
export default function FeatureBloc(t0) {
  const $ = _c(15);
  const {
    bloc,
    plan
  } = t0;
  let t1;
  if ($[0] !== bloc.available) {
    t1 = !bloc.available && <span className={styles.capsule}>Future release</span>;
    $[0] = bloc.available;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bloc.title || $[3] !== t1) {
    t2 = <div className={styles.title}>{bloc.title}{t1}</div>;
    $[2] = bloc.title;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== bloc.available || $[6] !== bloc.features || $[7] !== plan) {
    let t4;
    if ($[9] !== bloc.available || $[10] !== plan) {
      t4 = feature => <FeatureLine key={feature.title} feature={feature} plan={plan} available={bloc.available} />;
      $[9] = bloc.available;
      $[10] = plan;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = bloc.features.map(t4);
    $[5] = bloc.available;
    $[6] = bloc.features;
    $[7] = plan;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className={styles.featureBloc}>{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}